import { all } from 'redux-saga/effects';
import currentUserSagas from 'src/features/current-user/sagas';
import subscribersSaga from 'src/features/subscribers/sagas/index';
import productsSagas from '../features/products-v2/sagas';
import resourcesAssignmentSagas from '../features/resources-assignment/sagas';

// import UpdateSubscriberSaga from 'src/features/subscribers/sagas/updateSubscriberStatusSaga';

// Inspired by https://github.com/redux-saga/redux-saga/issues/160#issuecomment-308540204
const rootSaga = function* rootSaga() {
    yield all([
        ...currentUserSagas,
        ...resourcesAssignmentSagas,
        ...productsSagas,
        ...subscribersSaga,
        // fork(UpdateSubscriberSaga),
    ]);
};

export default rootSaga;
